import { Component, Input, inject } from '@angular/core';
import { DashboardInfoContainer } from '../../domain/model/dashboard-info-container';
import { Router } from '@angular/router';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';

@Component({
    selector: 'tnb-dashboard-info-box',
    templateUrl: './dashboard-info-box.component.html',
    styleUrls: [
        './dashboard-info-box.component.scss',
    ],
    standalone: false,
})
export class DashboardInfoBoxComponent {
    private router = inject(Router);
    netzbetreiberService = inject(NetzbetreiberService);

    @Input() public dashboardInfoDTO: DashboardInfoContainer;
    @Input() public isCurrentUserWestnetzUser: boolean;

    public openRoute(route: string) {
        this.router.navigate([
            route,
        ]);
    }
}
